"use client";

import React from "react";

/**
 * Table - Styled HTML table.
 *
 * @param {boolean} striped - Alternating row background
 * @param {boolean} bordered - Borders on all cells
 * @param {boolean} hover - Highlight rows on hover
 * @param {string} size - 'sm' for compact padding
 * @param {boolean} responsive - Wrap in horizontally scrollable container
 */
export function Table({
  children,
  striped = false,
  bordered = false,
  hover = false,
  size,
  responsive = false,
  className = "",
  ...props
}) {
  const classes = [
    "w-full",
    striped && "[&_tbody>tr:nth-child(odd)]:bg-lightGrey",
    bordered
      ? "border border-lightGrey3 [&_th]:border [&_th]:border-lightGrey3 [&_td]:border [&_td]:border-lightGrey3"
      : "border-b border-lightGrey3",
    hover && "[&_tbody>tr]:transition-colors [&_tbody>tr:hover]:bg-lightGrey2",
    size === "sm"
      ? "[&_th]:px-2 [&_th]:py-1 [&_td]:px-2 [&_td]:py-1 text-sm"
      : "[&_th]:px-3 [&_th]:py-2 [&_td]:px-3 [&_td]:py-2",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const table = (
    <table className={classes.trim()} {...props}>
      {children}
    </table>
  );

  if (responsive) {
    return <div className="overflow-x-auto">{table}</div>;
  }

  return table;
}

export default Table;
